<template>
	<div v-if="visible" class="app__message" :class="`app__message--${severity}`" role="status">
		<app-icon :name="icon" :size="19" :stroke-width="2" />
		<div class="app__message__text"><slot /></div>
		<button v-if="closable" type="button" class="app__message__close" aria-label="Zamknij komunikat" @click="visible = false">
			<app-icon name="x" :size="18" />
		</button>
	</div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
	severity: {
		type: String,
		default: 'info',
	},
	closable: Boolean,
});

const visible = ref(true);
const icon = computed(() => ({
	info: 'info',
	success: 'check',
	warn: 'alert',
	error: 'x',
}[props.severity] || 'info'));
</script>

<script>
export default {
	name: 'UiMessage',
};
</script>
